import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./AppHome.css";
import "../Admin/Admin.css";
import Header3 from "../Home/Header3";
import { useNavigate } from "react-router-dom";
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

const BASE_URL = "https://gym-invoice-back.onrender.com";

const currentYear = new Date().getFullYear();

function MemberPaymentManager() {
  const navigate = useNavigate();
  const [memberId, setMemberId] = useState("");
  const [memberData, setMemberData] = useState(null);
  const [payments, setPayments] = useState([]);
  const [viewMode, setViewMode] = useState("payment");
  const [membershipTypes, setMembershipTypes] = useState([]);
const [form, setForm] = useState({
  amount: "",
  date: getLocalDate(),
  paymentMethod: "",
  participation: ""
});
  const [feeAmount, setFeeAmount] = useState(0);
  const [dueDate, setDueDate] = useState(null);
  const [dialogMessage, setDialogMessage] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [cameraActive, setCameraActive] = useState(false);
  const [attendanceDates, setAttendanceDates] = useState([]);
  const [editForm, setEditForm] = useState({
    membershipType: "",
    date: getLocalDate()

  });




// Place this helper function somewhere at the top of your component file
const formatDate = (date) => {
  if (!date) return "-";
  const d = new Date(date);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};


  function getLocalDate() {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }



  // Keeps track of months we've auto-saved absent for (session only)
  const autoSavedMonthsRef = useRef(new Set());
  // Prevent concurrent auto-saves
  const autoSaveLockRef = useRef(false);

  useEffect(() => {
    const role = sessionStorage.getItem("userRole");
    if (!role) navigate("/");

    const fetchMembershipTypes = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/api/memberships`
        );
        setMembershipTypes(res.data || []);
      } catch (error) {
        console.error("Error fetching membership types:", error);
      }
    };
    fetchMembershipTypes();
  }, [navigate]);

  // ---- Add this helper function at the top ----
  function addMonthsExact(date, months) {
    const d = new Date(date);
    const originalDay = d.getDate();

    d.setMonth(d.getMonth() + months);

    // If month became shorter (Feb, Apr, etc.)
    if (d.getDate() < originalDay) {
      d.setDate(0); // last day of previous month
    }

    return d;
  }



  // ----- SEARCH & DATA LOAD -----
const handleSearch = async () => {
  if (!memberId) return;

  try {
    // 1️⃣ Fetch member info
    const res = await axios.get(
      `${BASE_URL}/api/members/by-member-id/${memberId}`
    );
    const member = res.data;

    // 2️⃣ If member not active → block
    if (!member || member.membershipStatus !== "ACTIVE") {
      setDialogMessage("⚠️ Member is not in ACTIVE status.");
      setShowDialog(true);
      setMemberData(null);
      setPayments([]);
      return;
    }

    // 3️⃣ Fetch payments
    const pay = await axios.get(
      `${BASE_URL}/api/payments/member/${memberId}`
    );
    const paymentHistory = Array.isArray(pay.data) ? pay.data : [];

    // 4️⃣ If NO payments → block
    if (paymentHistory.length === 0) {
      setDialogMessage("⚠️ Please make Initial Monthly Cycle Payment.");
      setShowDialog(true);
      setMemberData(null);
      setPayments([]);
      return;
    }

    // 5️⃣ If there ARE payments → allow
    setMemberData(member);
    setPayments(paymentHistory);

    // 6️⃣ Process last payment record
    const lastPayment = paymentHistory
      .slice()
      .sort((a, b) => new Date(b.date) - new Date(a.date))[0];

    setMemberData((prev) => ({
      ...prev,
      lastPaymentDate: lastPayment.date,
      lastPaymentStatus: lastPayment.status,
    }));


      // Membership duration mapping
     const plan = {
          "1 Month - Individual": 1,
          "1 Month Membership": 1,
          "3 Month - Individual": 3, "3 Month - Couple": 3,
          "6 Month - Individual": 6, "6 Month - Couple": 6,
          "12 Month - Individual": 12, "12 Month - Couple": 12,
          "Annual Membership - Individual": 12, "Annual Membership - Couple": 12
        };

    const planMonths = plan[member.membershipType] || 1;

        // 4️⃣ Find last DONE payment by cycle start date
        const donePayments = paymentHistory
          .filter(p => p.status === "Done")
          .sort((a, b) => new Date(b.date) - new Date(a.date));

        let baseDate;

if (donePayments.length === 0) {
      // ⭐ CASE 1: NO PAYMENT RECORD
      baseDate = new Date(member.joinedDate);
    } else {
      // ⭐ CASE 2: HAS PAYMENT RECORD
      baseDate = new Date(donePayments[0].date);
    }

    // 2️⃣ Add plan months to baseDate
  // 5️⃣ Calculate next billing cycle (date variable)
     const nextCycleDate = addMonthsExact(baseDate, planMonths);

     // Save it to state
     setDueDate(nextCycleDate);




      // Get membership fee
      const selectedType = membershipTypes.find(
        (t) => t.type === member.membershipType
      );
      const fee = selectedType ? selectedType.fee : 0;
      setFeeAmount(fee);

      // Set default form values (do not overwrite participation/paymentMethod if already set by auto-detect)
setForm((prev) => ({
  amount: fee,
  date: getLocalDate(),   // ← Use today
  paymentMethod: prev.paymentMethod || "",
  participation: prev.participation || ""
}));



      if ((membershipTypes || []).length === 0) {
        setDialogMessage("⚠️ Please wait, membership data still loading...");
        setShowDialog(true);
        return;
      }
    } catch (err) {
      console.error(err);
      setDialogMessage("❌ Error fetching member or payment data.");
      setShowDialog(true);
      setMemberData(null);
      setPayments([]);
    }
  };

  // ----- ATTENDANCE -----
  useEffect(() => {
    if (memberData && memberData.memberId) {
      fetchAttendance(memberData.memberId);
    } else {
      setAttendanceDates([]);
    }
    // We intentionally do not include attendanceDates here
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberData]);

  const fetchAttendance = async (id) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/api/attendance/member/${id}`
      );
      const dates = (res.data || []).map((a) => new Date(a.date));
      setAttendanceDates(dates);
    } catch (err) {
      console.error("Error fetching attendance:", err);
      setAttendanceDates([]);
    }
  };

  const handleScan = (result) => {
    if (result) {
      const memberIdFromQR = result.text.split("MemberID:")[1]?.split("\n")[0]?.trim();
      if (memberIdFromQR) {
        setMemberId(memberIdFromQR);
        // do NOT await — handleSearch will load data
        handleSearch();
      }
    }
  };

  // ----- AUTO-DETECT & AUTO-SAVE ABSENT (only once per month) -----
  useEffect(() => {
    // Preconditions
    if (!dueDate || !memberData || !memberData.memberId) return;

    // derive month key string for uniqueness
    const month = new Date(dueDate).getMonth();
    const year = new Date(dueDate).getFullYear();
    const monthKey = `${memberData.memberId}-${year}-${month}`;

     // helper: check payments array for any entry in this month
        const hasPaymentRecordForMonth = () => {
          if (!payments || payments.length === 0) return false;
          return payments.some(p => {
            // p.date may be ISO or a partial string - normalize
            const pd = new Date(p.date);
            return pd.getFullYear() === year && pd.getMonth() === month;
          });
        };

    // If we've already auto-saved for this month in this session, do nothing
    if (autoSavedMonthsRef.current.has(monthKey)) {
      // still set form based on attendance & payments but don't auto-save again
      applyParticipationFromData();
      return;
    }

     // helper to set participation/pmt method when payments/attendance indicate present/absent
      function applyParticipationFromData() {
        const attendancePresentNow = attendanceDates.some(
          d => d.getFullYear() === year && d.getMonth() === month
        );

        // ⭐ If attendance exists → Present
        if (attendancePresentNow) {
          setForm(prev => ({
            ...prev,
            participation: "Present",
            paymentMethod: ""
          }));
          return;
        }

        // ❌ REMOVED:
        //    "If there's a payment and no attendance, reflect Absent"
        //    So we do NOT auto-set Absent or load stored Absent payment.

        // ⭐ If no attendance → CLEAR participation (user chooses manually)
        setForm(prev => ({
          ...prev,
          participation: "",
          paymentMethod: "",
          amount: prev.amount // keep fee unchanged
        }));
      }





    const attendancePresent = attendanceDates.some(d => d.getFullYear() === year && d.getMonth() === month);

    // If there's already a payment/absent record, do not auto-save; just set form values accordingly
    if (hasPaymentRecordForMonth()) {
      // If there's a payment record and attendance exists, set Present, else if payment record exists and no attendance,
      // we assume the DB has the Absent or payment saved — reflect that by clearing auto actions.
      applyParticipationFromData();
      // mark as considered so we don't attempt to auto-save for this month again
      autoSavedMonthsRef.current.add(monthKey);
      return;
    }

    // If attendance exists -> auto set PRESENT (but do NOT auto-save)
    if (attendancePresent) {
      setForm(prev => ({
        ...prev,
        participation: "Present",
        paymentMethod: "" // user must choose
      }));
      return;
    }



    // Prevent auto-absent in the joined month
    const joined = new Date(memberData.joinedDate);
    if (joined.getFullYear() === year && joined.getMonth() === month) {
        // Set form to Present/Absent STATE only, but DO NOT auto save
        applyParticipationFromData();
        return;
    }


const today = new Date();
const duePlus30 = new Date(dueDate);
duePlus30.setDate(duePlus30.getDate() + 30);



    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dueDate, attendanceDates, memberData]); // intentionally not including payments to avoid re-trigger loops

  // ----- MANUAL SUBMIT -----
  const handlePaymentSubmit = async (e) => {
    if (e) e.preventDefault();

    try {
      // Validate Present case only (Absent removed)
      if (!form.participation || form.participation !== "Present") {
        setDialogMessage("⚠️ Only 'Present' participation is allowed.");
        setShowDialog(true);
        return;
      }

      if (!form.paymentMethod) {
        setDialogMessage("⚠️ Please select Payment Method.");
        setShowDialog(true);
        return;
      }

      // Fetch last bill number
      const lastPaymentRes = await axios.get(
        `${BASE_URL}/api/payments/last-bill`
      );

      let lastBillNo = lastPaymentRes.data?.billNo || "LFP1000";
      let nextBillNo = lastBillNo.startsWith("LFP")
        ? "LFP" + (parseInt(lastBillNo.replace("LFP", "")) + 1)
        : "LFP1000";

      // Always Present → Always amount
      const amountToSave = form.amount || feeAmount;

      const monthDate = new Date(dueDate).toISOString().substring(0, 10);

      // Check duplicate entry for same month
      const existing = payments.some((p) => {
        const pd = new Date(p.date);
        const md = new Date(monthDate);
        return pd.getFullYear() === md.getFullYear() && pd.getMonth() === md.getMonth();
      });

      if (existing) {
        setDialogMessage("⚠️ Payment already recorded for this month.");
        setShowDialog(true);
        return;
      }

      // Save Payment record (ABSENT REMOVED)
      await axios.post(`${BASE_URL}/api/payments`, {
        memberId,
        branchCode: memberData.branchCode,
        billNo: nextBillNo,
        amount: amountToSave,
        date: monthDate,
        payDate: new Date().toISOString().substring(0, 10),
        status: "Done",
        paymentMethod: form.paymentMethod,
        participation: "Present"
      });

      setDialogMessage(`✅ Successfully recorded payment!`);
      setShowDialog(true);

      // Refresh page data once
      handleSearch();

      navigate(`/success-payment/${nextBillNo}`);
      return;

    } catch (err) {
      console.error(err);
      setDialogMessage("❌ Failed to save payment!");
      setShowDialog(true);
    }
  };


   const fetchMembershipTypes = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/memberships`);
        setMembershipTypes(res.data);
      } catch (error) {
        console.error("Error fetching membership types:", error);
      }
    };
    const handleEditChange = (e) => {
      const { name, value } = e.target;
      setEditForm((prev) => ({ ...prev, [name]: value }));

      if (name === "membershipType") {
        const selected = membershipTypes.find((t) => t.type === value);
        if (selected) {
          setFeeAmount(selected.fee);
          setForm((prev) => ({ ...prev, amount: selected.fee }));
        }
      }
    };
const handlerollupubmit = async (e) => {
  e.preventDefault();

  try {
 if (!editForm.date) {
   setDialogMessage("⚠️ Please select the Bill Cycle Start Date.");
   setShowDialog(true);
   return;
 }


    if (!form.participation || !form.paymentMethod) {
      setDialogMessage("⚠️ Please select participation & payment method.");
      setShowDialog(true);
      return;
    }

    // ✅ 1. UPDATE MEMBER MEMBERSHIP TYPE
    await axios.put(
      `${BASE_URL}/api/members/${memberId}`,
      { membershipType: editForm.membershipType }
    );

    // ✅ 2. FETCH LAST BILL NUMBER
    const lastPaymentRes = await axios.get(
      `${BASE_URL}/api/payments/last-bill`
    );

    let lastBillNo = lastPaymentRes.data?.billNo || "LFP1000";
    let nextBillNo = lastBillNo.startsWith("LFP")
      ? "LFP" + (parseInt(lastBillNo.replace("LFP", "")) + 1)
      : "LFP1000";

    // PAYMENT DETAILS
    const paymentData = {
      memberId,
      branchCode: memberData.branchCode,
      billNo: nextBillNo,
      amount: feeAmount,
      date: editForm.date,
      payDate: new Date().toISOString().substring(0, 10),
      status: "Done",
      paymentMethod: form.paymentMethod,
      participation: "Present",
    };

    // ✅ 3. INSERT PAYMENT
    await axios.post(
      `${BASE_URL}/api/payments`,
      paymentData
    );

    setDialogMessage("✅ Rollup saved successfully!");
    setShowDialog(true);

    // refresh data
    handleSearch();

        navigate(`/success-payment/${nextBillNo}`);
        return;


  } catch (err) {
    console.error(err);
    setDialogMessage("❌ Failed to save rollup!");
    setShowDialog(true);
  }
};







  // ----- RENDER -----
  return (
    <div className="dashboard">
      <Header3 />
      <div className="payment-wrapper">
        <div className="payment-container">
          <h2> 💵 Member Payments</h2>

          <div className="search-box">
            <input
              type="text"
              id="memberIdInput"
              placeholder="Enter Member ID"
              value={memberId}
              onChange={(e) => setMemberId(e.target.value)}
            />
            <button onClick={handleSearch}>Search</button>
          </div>

          {memberData && (
            <>
              <table className="member-info-table">
                <tbody>
                  <tr>
                    <td colSpan="2" className="member-name-row">
                      <span className="member-name">{memberData.name}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Email:</strong> {memberData.email}
                    </td>
                    <td>
                      <strong>Phone No:</strong> {memberData.mobile}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Membership Type:</strong> {memberData.membershipType}
                    </td>
                    <td>
                                          <strong>Fee (Rs.):</strong> {feeAmount}
                                        </td>
                  </tr>
                   <tr>
                    <td colSpan="2">
                          <strong>Branch Code:</strong> {memberData.branchCode || "-"}
                        </td>
                      </tr>

                  <tr>
                <td colSpan="2">
                      <strong>Last Bill Cycle:</strong>{" "}
                      {memberData.lastPaymentDate ? (
                        (() => {
                         const d = new Date(memberData.lastPaymentDate);
                             const dd = String(d.getDate()).padStart(2, "0");
                             const mm = String(d.getMonth() + 1).padStart(2, "0");
                             const yyyy = d.getFullYear();

                             const formattedDate = `${dd}/${mm}/${yyyy}`;
                          const status = memberData.lastPaymentStatus || "";

                          return `${formattedDate} (${status})`;
                        })()
                      ) : (
                        "-"
                      )}
                    </td>

                  </tr>
                  <tr>
                    <td colSpan="2">
                      <strong>To Be Paid Bill Cycle:</strong>{" "}
                      {dueDate ? formatDate(dueDate) : "-"}

                    </td>
                  </tr>
                </tbody>
              </table>

              <div className="toggle-buttons" style={{ margin: "15px 0" }}>
                <button
                  className={`toggle-button ${viewMode === "payment" ? "active" : ""}`}
                  onClick={() => setViewMode("payment")}
                >
                  Payment
                </button>

                <button
                                  className={`toggle-button ${viewMode === "rollup" ? "active" : ""}`}
                                  onClick={() => setViewMode("rollup")}
                                >
                                  Roll Up
                                </button>

                <button
                  className={`toggle-button ${viewMode === "attendance" ? "active" : ""}`}
                  onClick={() => setViewMode("attendance")}
                >
                  Attendance View
                </button>
              </div>

              {viewMode === "payment" && (
                <div className="payment-card">
                  <form onSubmit={handlePaymentSubmit}>
                    <label>Amount (Rs.)</label>
                    <input
                      type="number"
                      value={form.amount}
                      onChange={(e) => setForm({ ...form, amount: e.target.value })}
                      required
                    />

                    <label>Date</label>
                    <input
                      type="date"
                      value={form.date}
                      onChange={(e) => setForm({ ...form, date: e.target.value })}
                      required
                    />

                    <label>Participation</label>
                    <select
                      value={form.participation}
                      onChange={(e) => setForm({ ...form, participation: e.target.value, paymentMethod: "" })}
                      required
                    >
                      <option value="">Select Participation</option>
                      <option value="Present">Present</option>

                    </select>

                    {form.participation === "Present" && (
                      <>
                        <label>Payment Method</label>
                        <select
                          value={form.paymentMethod}
                          onChange={(e) => setForm({ ...form, paymentMethod: e.target.value })}
                          required
                        >
                          <option value="">Select Method</option>
                          <option value="Cash">Cash</option>
                          <option value="Online">Online</option>
                        </select>
                      </>
                    )}

                    <div className="payment-buttons">
                      <button className="pay-button" type="submit">
                        ✅ Submit
                      </button>
                    </div>
                  </form>
                </div>
              )}

              {viewMode === "rollup" && (
                              <div className="payment-card">
                                <form onSubmit={handlerollupubmit}>

                                <label>Amount (Rs.)</label>
                                <input
                                  type="number"
                                  value={form.amount}
                                  onChange={(e) => setForm({ ...form, amount: e.target.value })}
                                  readOnly  // 🔒 READ-ONLY
                                />


                                   <div className="form-row">
                                                    <label>Bill Cycle Start Date</label>
                                                    <input type="date" name="date" value={editForm.date} onChange={handleEditChange} />
                                                  </div>



                                  <label>Participation</label>
                                  <select
                                    value={form.participation}
                                    onChange={(e) => setForm({ ...form, participation: e.target.value, paymentMethod: "" })}
                                    required
                                  >
                                    <option value="">Select Participation</option>
                                    <option value="Present">Present</option>

                                  </select>

                                  {form.participation === "Present" && (
                                    <>
                                      <label>Payment Method</label>
                                      <select
                                        value={form.paymentMethod}
                                        onChange={(e) => setForm({ ...form, paymentMethod: e.target.value })}
                                        required
                                      >
                                        <option value="">Select Method</option>
                                        <option value="Cash">Cash</option>
                                        <option value="Online">Online</option>
                                      </select>
                                    </>
                                  )}

                                  <div className="payment-buttons">
                                    <button className="pay-button" type="submit">
                                      ✅ Submit
                                    </button>
                                  </div>
                                </form>
                              </div>
                            )}


              {viewMode === "attendance" && (
                <div className="attendance-calendar">
                  <h3>Attendance Calendar</h3>
                  <Calendar
                    tileClassName={({ date, view }) => {
                      if (view === "month") {
                        const attended = attendanceDates.find(
                          (d) =>
                            d.getFullYear() === date.getFullYear() &&
                            d.getMonth() === date.getMonth() &&
                            d.getDate() === date.getDate()
                        );
                        if (attended) return "attended-day";
                      }
                    }}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {showDialog && (
        <div className="dialog-overlay">
          <div className="dialog-box">
            <p>{dialogMessage}</p>
            <button onClick={() => setShowDialog(false)}>OK</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default MemberPaymentManager;
